import Swiper, {Autoplay, Navigation, Scrollbar} from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

window.boxesTypesSliderInit = function boxesTypesSliderInit() {
  let boxesTypesSwiperWr = document.querySelectorAll('.boxes-types-swiper-wr');
  boxesTypesSwiperWr.forEach((el) => {
    if (el) {
      let swiperEl = el.querySelector('.swiper');
      let nextEl = el.querySelector('.swiper-button-next');
      let prevEl = el.querySelector('.swiper-button-prev');
      let scrollbarEl = el.querySelector('.swiper-scrollbar');
      let slidesCount = el.querySelectorAll('.swiper-slide').length;
      let wrapper = swiperEl.querySelector('.swiper-wrapper');
      let swiper = new Swiper(swiperEl, {
        modules: [Autoplay, Navigation, Scrollbar],
        observer: true,
        observeParents: true,
        spaceBetween: 14,
        slidesPerView: 1.9,
        threshold: 10,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        scrollbar: {
          el: scrollbarEl,
          draggable: true,
          snapOnRelease: true,
        },
        breakpoints: {
          451: {
            spaceBetween: 16,
            slidesPerView: 1.5,
          },
          640: {
            spaceBetween: 16,
            slidesPerView: 2,
          },
          768: {
            spaceBetween: 16,
            slidesPerView: 3,
          },
          1023: {
            spaceBetween: 24,
            slidesPerView: 3,
          },
          1200: {
            spaceBetween: 28,
            slidesPerView: 3,
          },
        },
        autoplay: false,
      });
      /*swiperObserver(swiper);*/
    }
  });
}